<div class="content">
  <div class="box">
    <spinner class="no-pad spinner" colorName="blue"></spinner>
    <div class="title">{{ title }}</div>
    @if (body) {
    <div class="body">{{ body }}</div>
    }
  </div>
</div>
